import { lazy } from 'react';

// 房态
const RealtimeRoomState = lazy(
  () => import('@/pages/roomState/realtime' /* webpackChunkName: "RealtimeRoomState" */),
);
const FutureRoomState = lazy(
  () => import('@/pages/roomState/future' /* webpackChunkName: "FutureRoomState" */),
);
const TodayPrice = lazy(
  () => import('@/pages/roomState/todayPrice' /* webpackChunkName: "TodayPrice" */),
);
const RoomAmenity = lazy(
  () => import('@/pages/roomState/roomAmenity' /* webpackChunkName: "RoomAmenity" */),
);
const MatchCalendar = lazy(
  () => import('@/pages/roomState/matchCalendar' /* webpackChunkName: "MatchCalendar" */),
);
const RoomLinen = lazy(
  () => import('@/pages/roomState/roomLinen' /* webpackChunkName: "RoomLinen" */),
);

const TakeCareOf = lazy(
  () => import('@/pages/roomState/takeCareOf' /* webpackChunkName: "TakeCareOf" */),
);

const TodoTaskList = lazy(
  () => import('@/pages/roomState/todoTask/AllTaskList' /* webpackChunkName: "AllTodoTaskList" */),
);
const RoomManagement = lazy(
  () => import('@/pages/roomState/roomManagement' /* webpackChunkName: "RoomManagement" */),
);

const CleanList = lazy(
  () => import('@/pages/roomState/roomClean' /* webpackChunkName: "CleanList" */),
);

// 订单
// 房间订单
const Order = lazy(() => import('@/pages/order' /* webpackChunkName: "order" */));
const OrderDetail = lazy(() => import('@/pages/order/detail' /* webpackChunkName: "detail" */));
const Reservation = lazy(
  () => import('@/pages/order/reservation' /* webpackChunkName: "reservation" */),
);
const CheckIn = lazy(() => import('@/pages/order/checkIn' /* webpackChunkName: "checkIn" */));
const CancelReservation = lazy(
  () => import('@/pages/order/cancelReservation' /* webpackChunkName: "cancelReservation" */),
);
const CheckOut = lazy(() => import('@/pages/order/checkOut' /* webpackChunkName: "checkOut" */));
const RoomOrderQuery = lazy(
  () => import('@/pages/order/roomOrderQuery' /* webpackChunkName: "RoomOrderQuery" */),
);
const FrontDesk = lazy(() => import('@/pages/order/frontDesk' /* webpackChunkName: "frontDesk" */));
const FrontDeskOrderDetail = lazy(
  () => import('@/pages/order/frontDeskDetail' /* webpackChunkName: "FrontDeskOrderDetail" */),
);
const FrontGoodsOrder = lazy(
  () => import('@/pages/order/frontGoodsOrder' /* webpackChunkName: "FrontGoodsOrder" */),
);
const FrontGoodsOrderDetail = lazy(
  () => import('@/pages/order/frontGoodsDetail' /* webpackChunkName: "FrontGoodsOrderDetail" */),
);
const MemberRecharge = lazy(
  () => import('@/pages/order/memberRecharge' /* webpackChunkName: "memberRecharge" */),
);
const MemberRechargeOrderDetail = lazy(
  () =>
    import(
      '@/pages/order/memberRechargeDetail' /* webpackChunkName: "MemberRechargeOrderDetail" */
    ),
);
const MemberCard = lazy(
  () => import('@/pages/order/memberCard' /* webpackChunkName: "memberCard" */),
);
const MemberCardOrderDetail = lazy(
  () => import('@/pages/order/memberCardDetail' /* webpackChunkName: "MemberCardOrderDetail" */),
);
const SelfServiceList = lazy(
  () => import('@/pages/order/selfService/orderList' /* webpackChunkName: "SelfServiceList" */),
);
const SelfServiceDetail = lazy(
  () => import('@/pages/order/selfService/orderDetail' /* webpackChunkName: "SelfServiceDetail" */),
);
const SelfServiceReport = lazy(
  () => import('@/pages/order/selfServiceReport' /* webpackChunkName: "SelfServiceReport" */),
);
const OrderOperationLog = lazy(
  () => import('@/pages/order/operationLog' /* webpackChunkName: "OrderOperationLog" */),
);

const CrsInvitayion = lazy(
  () => import('@/pages/order/crsInvitation' /* webpackChunkName: "CrsInvitayion" */),
);

// 商品
const GoodsList = lazy(() => import('@/pages/goods' /* webpackChunkName: "GoodsList" */));
const GoodsSettle = lazy(
  () => import('@/pages/goods/settle' /* webpackChunkName: "GoodsSettle" */),
);
const StoreStorage = lazy(
  () => import('@/pages/goods/storeStorage' /* webpackChunkName: "StoreStorage" */),
);

const RoomInventoryList = lazy(
  () => import('@/pages/inventory' /* webpackChunkName: "RoomInventoryList" */),
);

const CardSaleAssistant = lazy(
  () => import('@/pages/guest/cardSaleAssistant' /* webpackChunkName: "CardSaleAssistant" */),
);
const GuestList = lazy(() => import('@/pages/guest' /* webpackChunkName: "guestList" */));
const GuestQueryList = lazy(
  () => import('@/pages/guest/guestQuery' /* webpackChunkName: "guestQuery" */),
);
const LeaveVisitList = lazy(
  () => import('@/pages/guest/leaveShopVisit' /* webpackChunkName: "LeaveVisitList" */),
);
const ChargeRecord = lazy(
  () => import('@/pages/guest/chargeRecord' /* webpackChunkName: "ChargeRecord" */),
);
const GiveawayCouponHistory = lazy(
  () =>
    import('@/pages/guest/giveAwayCouponHistory' /* webpackChunkName: "GiveawayCouponHistory" */),
);
const ConsumptionAnalysisReport = lazy(
  () => import('@/pages/guest/guestAnalysis' /* webpackChunkName: "GuestAnalysisReport" */),
);
const HotelPointsTransactionHistory = lazy(
  () =>
    import(
      '@/pages/guest/hotelPointsTransactionHistory' /* webpackChunkName: "HotelPointsTransactionHistory" */
    ),
);

const StandardStock = lazy(
  () => import('@/pages/goods/standardStock' /* webpackChunkName: "StandardStock" */),
);
const GoodsManagement = lazy(
  () => import('@/pages/goods/goodsManagement' /* webpackChunkName: "GoodsManagement" */),
);
const LaundryList = lazy(
  () => import('@/pages/goods/goodsStock/laundryList' /* webpackChunkName: "LaundryList" */),
);
const Record = lazy(() => import('@/pages/goods/record' /* webpackChunkName: "Record" */));

const GoodsStock = lazy(
  () => import('@/pages/goods/goodsStock' /* webpackChunkName: "GoodsStock" */),
);

// 外设管理
const PeripheralManagement = lazy(
  () => import('@/pages/goods/peripheralManagement' /* webpackChunkName: "PeripheralManagement" */),
);
// 外设租借
const PeripheralRental = lazy(
  () => import('@/pages/goods/peripheralRental' /* webpackChunkName: "PeripheralRental" */),
);
// 外设库存
const PeripheralStock = lazy(
  () => import('@/pages/goods/peripheralStock' /* webpackChunkName: "PeripheralStock" */),
);

// 设备
const ComputerList = lazy(
  () => import('@/pages/device/computer/index' /* webpackChunkName: "ComputerList" */),
);
const ComputerRecord = lazy(
  () => import('@/pages/device/computer/record' /* webpackChunkName: "ComputerRecord" */),
);
const ComputerCfg = lazy(
  () => import('@/pages/device/computerCfg' /* webpackChunkName: "ComputerCfg" */),
);
const CardList = lazy(() => import('@/pages/device/card' /* webpackChunkName: "CardList" */));
const PriceBrandPortal = lazy(
  () => import('@/pages/device/priceBrand/portal' /* webpackChunkName: "PriceBrandPortal" */),
);
const PriceBrandEditor = lazy(
  () => import('@/pages/device/priceBrand/screenEditor' /* webpackChunkName: "PriceBrandEditor" */),
);
const ReadIDCard = lazy(() => import('@/pages/device/idCard' /* webpackChunkName: "ReadIDCard" */));
const SystemPlatform = lazy(
  () => import('@/pages/device/systemPlatform' /* webpackChunkName: "SystemPlatform" */),
);

// 渠道
const CentralReservation = lazy(
  () => import('@/pages/channel/centralReservation' /* webpackChunkName: "CentralReservation" */),
);
const DirectPromotion = lazy(
  () => import('@/pages/channel/directPromotion' /* webpackChunkName: "DirectPromotion" */),
);
const ChannelOrder = lazy(
  () => import('@/pages/channel/channelOrder' /* webpackChunkName: "ChannelOrder" */),
);
const ChannelAutoCheckDetail = lazy(
  () =>
    import('@/pages/reports/otaBill/AutoDetail' /* webpackChunkName: "ChannelAutoCheckDetail" */),
);

const PriceChangeApprove = lazy(
  () => import('@/pages/channel/priceChangeApprove' /* webpackChunkName: "PriceChangeApprove" */),
);

const CrsInfoApprove = lazy(
  () => import('@/pages/channel/crsInfoApprove' /* webpackChunkName: "CrsInfoApprove" */),
);

const AroundHotelPriceStat = lazy(
  () =>
    import('@/pages/channel/aroundHotelPriceStat' /* webpackChunkName: "AroundHotelPriceStat" */),
);
const PriceCalendar = lazy(
  () => import('@/pages/channel/priceCalendar' /* webpackChunkName: "PriceCalendar" */),
);

// CRS 促销
const CentralReservationPromotion = lazy(
  () => import('@/pages/channel/promotion' /* webpackChunkName: "CentralReservationPromotion" */),
);

const StandardPrices = lazy(
  () => import('@/pages/channel/standardPrices' /* webpackChunkName: "StandardPrices" */),
);
const MeituanDirect = lazy(
  () => import('@/pages/channel/meituanDirect/index' /* webpackChunkName: "MeituanDirect" */),
);
const OperateLog = lazy(
  () => import('@/pages/channel/operateLog' /* webpackChunkName: "OperateLog" */),
);
const Exhibition = lazy(
  () => import('@/pages/channel/exhibition' /* webpackChunkName: "Exhibition" */),
);
const SurroundingRoomPrice = lazy(
  () =>
    import(
      '@/pages/channel/surroundingRoomPrice/tabContainer' /* webpackChunkName: "SurroundingRoomPrice" */
    ),
);
const CtripDirect = lazy(
  () => import('@/pages/channel/ctripDirect/index' /* webpackChunkName: "CtripDirect" */),
);
const TikTokDirect = lazy(
  () => import('@/pages/channel/tiktokDirect/index' /* webpackChunkName: "TikTokDirect" */),
);

// 报表
const CashFlowApply = lazy(
  () => import('@/pages/reports/cashFlowApply' /* webpackChunkName: "CashFlowApply" */),
);
const CashFlowApplyGroup = lazy(
  () => import('@/pages/reports/cashFlowApplyGroup' /* webpackChunkName: "CashFlowApplyGroup" */),
);
const ReportsDaily = lazy(
  () => import('@/pages/reports/daily' /* webpackChunkName: "ReportsDaily" */),
);
const ReportsOutlay = lazy(
  () => import('@/pages/reports/outlay' /* webpackChunkName: "ReportsOutlay" */),
);
const ReportsWyBill = lazy(
  () => import('@/pages/reports/wyBill' /* webpackChunkName: "ReportsWyBill" */),
);
const ReconciliationBIReport = lazy(
  () => import('@/pages/bill/reconciliationReport' /* webpackChunkName: "ReconciliationReport" */),
);

const HotelManagement = lazy(
  () => import('@/pages/channel/hotelManagement' /* webpackChunkName: "HotelManagement" */),
);
const ReportsHandover = lazy(
  () => import('@/pages/reports/handover' /* webpackChunkName: "ReportsHandover" */),
);
const ReportsOtaBill = lazy(
  () => import('@/pages/reports/otaBill' /* webpackChunkName: "ReportsOtaBill" */),
);
const ReportsOtaBillDetail = lazy(
  () => import('@/pages/reports/otaBill/detail' /* webpackChunkName: "ReportsOtaBillDetail" */),
);
const ReportsMemberCard = lazy(
  () => import('@/pages/reports/memberCard' /* webpackChunkName: "ReportsMemberCard" */),
);
const ReportsAccountBook = lazy(
  () => import('@/pages/reports/accountBook' /* webpackChunkName: "ReportsMemberCard" */),
);
const ReportsCrossNARefund = lazy(
  () => import('@/pages/reports/crossNARefund' /* webpackChunkName: "ReportsCrossNARefund" */),
);
const RefundAccounts = lazy(
  () => import('@/pages/reports/refundAccounts' /* webpackChunkName: "refundAccounts" */),
);
const PayOrderPortal = lazy(
  () => import('@/pages/bill/payOrderList' /* webpackChunkName: "PayOrderPortal" */),
);
const ManageReports = lazy(
  () => import('@/pages/reports/manageReports' /* webpackChunkName: "ManageReports" */),
);
const InvestmentCalculation = lazy(
  () =>
    import('@/pages/reports/investmentCalculation' /* webpackChunkName: "InvestmentCalculation" */),
);

// 账务查询
const BillingQuery = lazy(
  () => import('@/pages/bill/billingQuery' /* webpackChunkName: "BillingQuery" */),
);
// 开票记录
const InvoiceHistory = lazy(
  () => import('@/pages/bill/invoiceHistory' /* webpackChunkName: "InvoiceHistory" */),
);

// 业绩预测
const IncomeForecast = lazy(
  () => import('@/pages/reports/incomeForecast' /* webpackChunkName: "IncomeForecast" */),
);
// 游戏排行
const GameAppRank = lazy(
  () => import('@/pages/device/gameRank' /* webpackChunkName: "GameAppRank" */),
);

// 管理
const SystemAccount = lazy(
  () => import('@/pages/manage/systemAccount' /* webpackChunkName: "SystemAccount" */),
);
const ReleaseLog = lazy(
  () => import('@/pages/manage/releaseLog' /* webpackChunkName: "ReleaseLog" */),
);
const EmployeeManage = lazy(
  () => import('@/pages/manage/employeeManage/index' /* webpackChunkName: "EmployeeManage" */),
);
const GroupEmployeeManage = lazy(
  () => import('@/pages/manage/groupEmployeeManage' /* webpackChunkName: "GroupEmployeeManage" */),
);
const ServiceNotice = lazy(
  () => import('@/pages/manage/serviceNotice' /* webpackChunkName: "ServiceNotice" */),
);
// 集团系统公告
const SystemNoticeGroup = lazy(
  () => import('@/pages/manage/systemNoticeGroup' /* webpackChunkName: "SystemNoticeGroup" */),
);
// 系统公告
const SystemNotice = lazy(
  () => import('@/pages/manage/systemNotice' /* webpackChunkName: "SystemNotice" */),
);
const ShopownerSOP = lazy(
  () => import('@/pages/manage/shopownerSOP' /* webpackChunkName: "ShopownerSOP" */),
);
const ShopSOP = lazy(() => import('@/pages/manage/shopSOP' /* webpackChunkName: "ShopSOP" */));
const LicenseManage = lazy(
  () => import('@/pages/manage/licenseManage' /* webpackChunkName: "LicenseManage" */),
);

const AttendanceRecordReport = lazy(
  () => import('@/pages/manage/attendanceRecord' /* webpackChunkName: "AttendanceRecordReport" */),
);
const ClientIcon = lazy(
  () => import('@/pages/manage/clientIcon' /* webpackChunkName: "ClientIcon" */),
);
const EmployeePlayDuration = lazy(
  () =>
    import('@/pages/manage/employeePlayDuration' /* webpackChunkName: "EmployeePlayDuration" */),
);

// 历史遗留
const BillList = lazy(() => import('@/pages/bill' /* webpackChunkName: "BillList" */));

const WechatMarketing = lazy(
  () =>
    import('@/pages/channel/wechatMarketing/management' /* webpackChunkName: "WechatMarketing" */),
);

const OperatingExpenses = lazy(
  () =>
    import(
      '@/pages/expenses/operating' /* webpackChunkName: "Expenses" */ /* webpackPrefetch: true */
    ),
);
// 用户满意度
const CustomerSatisfaction = lazy(
  () =>
    import('@/pages/quality/customerSatisfaction' /* webpackChunkName: "CustomerSatisfaction" */),
);

// 区域计划列表
const RegionPlanList = lazy(
  () => import('@/pages/regionPlan/monthPlanList' /* webpackChunkName: "RegionPlanList" */),
);

// 区域计划详情
const RegionPlanDetail = lazy(
  () => import('@/pages/regionPlan/monthPlanDetail' /* webpackChunkName: "RegionPlanDetail" */),
);

/* 集团页面 */

// 房务
// 预到关怀统计
const TakeCareOfStaticGroup = lazy(
  () =>
    import(
      '@/pages/roomState/takeCareOfStaticGroup' /* webpackChunkName: "TakeCareOfStaticGroup" */
    ),
);
const LinenStaticGroup = lazy(
  () => import('@/pages/roomState/linenStaticGroup' /* webpackChunkName: "LinenStaticGroup" */),
);
const AmenityStaticGroup = lazy(
  () => import('@/pages/roomState/amenityStaticGroup' /* webpackChunkName: "AmenityStaticGroup" */),
);
// 远期提醒统计
const FeatureAlertStaticGroup = lazy(
  () =>
    import(
      '@/pages/roomState/featureAlertStaticGroup' /* webpackChunkName: "FeatureAlertStaticGroup" */
    ),
);

// 订单

// 集团-入住换房统计
const LiveExchangeRoomBIGroup = lazy(
  () =>
    import(
      '@/pages/order/groupLiveExchangeRoomBI' /* webpackChunkName: "LiveExchangeRoomBIGroup" */
    ),
);

// 门店入住换房统计
const LiveExchangeRoomBI = lazy(
  () => import('@/pages/order/liveExchangeRoomBI' /* webpackChunkName: "LiveExchangeRoomBI" */),
);

// 改夜审价统计
const ChangeNightPriceBIGroup = lazy(
  () =>
    import(
      '@/pages/order/groupChangeNightPriceBI' /* webpackChunkName: "ChangeNightPriceBIGroup" */
    ),
);

// 宾客

// 门店赠券统计
const StoreVoucherStat = lazy(
  () =>
    import('@/pages/guest/storeVoucherStatGroup' /* webpackChunkName: "StoreVoucherStatGroup" */),
);

const LeaveVisitStatGroup = lazy(
  () => import('@/pages/guest/leaveVisitStatGroup' /* webpackChunkName: "LeaveVisitStatGroup" */),
);

const GroupFlywheelBoard = lazy(
  () => import('@/pages/guest/groupFlywheelBoard' /* webpackChunkName: "GroupFlywheelBoard" */),
);

// 财务
const AutoCheckBillGroup = lazy(
  () => import('@/pages/bill/autoCheckBillGroup' /* webpackChunkName: "AutoCheckBillGroup" */),
);
// 超时房费核查
const OvertimeRoomRateGroup = lazy(
  () =>
    import('@/pages/bill/overtimeRoomRateGroup' /* webpackChunkName: "OvertimeRoomRateGroup" */),
);

const OutstandingAccountsGroup = lazy(
  () =>
    import(
      '@/pages/bill/outstandingAccountsGroup' /* webpackChunkName: "OutstandingAccountsGroup" */
    ),
);
// 集团冲调统计
const AdjustmentStatisticsGroup = lazy(
  () =>
    import(
      '@/pages/bill/adjustmentStatisticsGroup' /* webpackChunkName: "AdjustmentStatisticsGroup" */
    ),
);

const InvoiceStatisticsGroup = lazy(
  () =>
    import('@/pages/bill/invoiceStatisticsGroup' /* webpackChunkName: "InvoiceStatisticsGroup" */),
);

// 设备

// 电脑配置统计
const ComputerConfigStatGroup = lazy(
  () =>
    import(
      '@/pages/device/computerConfigStatGroup' /* webpackChunkName: "ComputerConfigStatGroup" */
    ),
);

// 异常上机记录
const AbnormalBoardRecordGroup = lazy(
  () =>
    import(
      '@/pages/device/abnormalBoardRecordGroup' /* webpackChunkName: "AbnormalBoardRecordGroup" */
    ),
);

// 游戏排行
const gameRankGroup = lazy(
  () => import('@/pages/device/gameRankGroup' /* webpackChunkName: "gameRankGroup" */),
);

// 渠道
const GroupPriceChangeApprove = lazy(
  () =>
    import(
      '@/pages/channel/priceChangeApprove/group' /* webpackChunkName: "PriceChangeApproveGroup" */
    ),
);
const GroupUnifiedControlPromotion = lazy(
  () =>
    import(
      '@/pages/channel/unifiedControlPromotion/index' /* webpackChunkName: "GroupUnifiedControlPromotion" */
    ),
);
// // 房价查询看板
// const RoomPriceInquiryBoardGroup = lazy(
//   () =>
//     import(
//       '@/pages/channel/roomPriceInquiryBoardGroup' /* webpackChunkName: "RoomPriceInquiryBoardGroup" */
//     ),
// );
const GroupDiscountRateAlert = lazy(
  () =>
    import(
      '@/pages/channel/discountRateAlert/index' /* webpackChunkName: "GroupDiscountRateAlert" */
    ),
);

// 业绩
// 经营报告统计
const OperationalReportGroup = lazy(
  () =>
    import(
      '@/pages/reports/operationalReportGroup' /* webpackChunkName: "OperationalReportGroup" */
    ),
);
// 业绩目标
const PerformanceTarget = lazy(
  () => import('@/pages/reports/performanceTarget' /* webpackChunkName: "PerformanceTarget" */),
);
// 业绩目标-详情
const PerformanceTargetDetail = lazy(
  () =>
    import(
      '@/pages/reports/performanceTargetDetail' /* webpackChunkName: "PerformanceTargetDetail" */
    ),
);
// 业绩预测
const IncomeForecastGroup = lazy(
  () => import('@/pages/reports/incomeForecastGroup' /* webpackChunkName: "IncomeForecastGroup" */),
);

const BuryPriceAnalysisGroup = lazy(
  () =>
    import(
      '@/pages/reports/buryPriceAnalysisGroup' /* webpackChunkName: "BuryPriceAnalysisGroup" */
    ),
);
const MinPriceGroup = lazy(
  () => import('@/pages/channel/minPrice' /* webpackChunkName: "GroupMinPrice" */),
);

const CashFlowAnalysisGroup = lazy(
  () =>
    import('@/pages/reports/cashFlowAnalysisGroup' /* webpackChunkName: "CashFlowAnalysisGroup" */),
);

const SingleStorePerformanceGroup = lazy(
  () =>
    import(
      '@/pages/reports/singleStorePerformanceGroup' /* webpackChunkName: "SingleStorePerformanceGroup" */
    ),
);

const PriceDifferenceStatisticsGroup = lazy(
  () =>
    import(
      '@/pages/reports/priceDifferenceStatisticsGroup' /* webpackChunkName: "PriceDifferenceStatisticsGroup" */
    ),
);

// 品质
// 集团用户满意度
const GroupCustomerSatisfaction = lazy(
  () =>
    import(
      '@/pages/quality/customerSatisfactionGroup' /* webpackChunkName: "CustomerSatisfactionGroup" */
    ),
);

// 集团SOP执行统计页
const SopExcuStatistic = lazy(
  () => import('@/pages/quality/sopExcuStatistic' /* webpackChunkName: "SopExcuStatistic" */),
);
// 质检项报表
const GroupStoreInspect = lazy(
  () => import('@/pages/quality/groupStoreInspect' /* webpackChunkName: "GroupStoreInspect" */),
);

// 品质门店
const GroupQualityStore = lazy(
  () => import('@/pages/quality/qualityStoreGroup' /* webpackChunkName: "GroupQualityStore" */),
);

// 集团客房品质
const GroupQualityRoom = lazy(
  () => import('@/pages/quality/qualityRoomGroup' /* webpackChunkName: "GroupQualityRoom" */),
);

// 巡店统计
const GroupShopTour = lazy(
  () => import('@/pages/quality/shopTourGroup' /* webpackChunkName: "GroupShopTour" */),
);

// 集团店长考勤统计
const ShopAttendanceRecordGroup = lazy(
  () =>
    import(
      '@/pages/manage/shopAttendanceRecordGroup' /* webpackChunkName: "ShopAttendanceRecordGroup" */
    ),
);

// SOP列表页
const SopReport = lazy(
  () => import('@/pages/quality/sopReport' /* webpackChunkName: "sopReport" */),
);
// sop详情页
const SopReportDetail = lazy(
  () => import('@/pages/quality/sopReportDetail' /* webpackChunkName: "sopReportDetail" */),
);

// 门店客房品质
const QualityRoom = lazy(
  () => import('@/pages/quality/qualityRoom' /* webpackChunkName: "QualityRoom" */),
);

// 集团企微数据统计
const GroupWechatDataStat = lazy(
  () => import('@/pages/channel/wechatDataStatGroup' /* webpackChunkName: "GroupWechatDataStat" */),
);

// 管理
// 门店档案
const ShopProfile = lazy(
  () => import('@/pages/manage/shopProfile' /* webpackChunkName: "ShopProfile" */),
);
const LicenseStaticGroup = lazy(
  () => import('@/pages/manage/licenseStaticGroup' /* webpackChunkName: "LicenseStaticGroup" */),
);

// 帮助
const ManualBook = lazy(
  () => import('@/pages/help/manualBook' /* webpackChunkName: "ManualBook" */),
);
const StoreAddressBook = lazy(
  () => import('@/pages/help/storeAddress' /* webpackChunkName: "StoreAddressBook" */),
);
const CompanyAddressBook = lazy(
  () => import('@/pages/help/companyAddress' /* webpackChunkName: "CompanyAddressBook" */),
);
const OnlineSupport = lazy(
  () => import('@/pages/help/onlineSupport' /* webpackChunkName: "OnlineSupport" */),
);
const ServiceOrder = lazy(
  () => import('@/pages/help/serviceOrder' /* webpackChunkName: "ServiceOrder" */),
);
const ApplicationBook = lazy(
  () => import('@/pages/help/applicationBook' /* webpackChunkName: "ApplicationBook" */),
);
const AboutApplication = lazy(
  () => import('@/pages/help/about' /* webpackChunkName: "AboutApplication" */),
);
const Complaint = lazy(() => import('@/pages/help/complaint' /* webpackChunkName: "Complaint" */));
// 员工上机统计
const EmployeePlayStatGroup = lazy(
  () =>
    import('@/pages/manage/employeePlayStatGroup' /* webpackChunkName: "EmployeePlayStatGroup" */),
);
// 集团店长人力陈本
const GroupLaborCost = lazy(
  () => import('@/pages/manage/laborCost/group' /* webpackChunkName: "GroupLaborCost" */),
);

// 店长人力成本
const ShopLaborCost = lazy(
  () => import('@/pages/manage/laborCost/shop' /* webpackChunkName: "ShopLaborCost" */),
);
// 看板
const ForecastDashboard = lazy(
  () => import('@/pages/dashboard/forecast' /* webpackChunkName: "ForecastDashboard" */),
);
const CashflowDashboard = lazy(
  () => import('@/pages/dashboard/cashflow' /* webpackChunkName: "CashflowDashboard" */),
);
const AchievementDashboard = lazy(
  () => import('@/pages/dashboard/achievement' /* webpackChunkName: "AchievementDashboard" */),
);
const QualityDashboard = lazy(
  () => import('@/pages/dashboard/quality' /* webpackChunkName: "QualityDashboard" */),
);
const AchievementAnalysisDashboard = lazy(
  () =>
    import(
      '@/pages/dashboard/achievementAnalysis' /* webpackChunkName: "AchievementAnalysisDashboard" */
    ),
);

// steam
const SteamHomeIframe = lazy(
  () => import('@/pages/steam/homeIframe' /* webpackChunkName: "SteamHomeIframe" */),
);

export default {
  RealtimeRoomState,
  FutureRoomState,
  TodayPrice,
  RoomAmenity,
  RoomLinen,
  TakeCareOf,
  MatchCalendar,
  TodoTaskList,
  RoomManagement,

  Order,
  OrderDetail,
  Reservation,
  CheckIn,
  CancelReservation,
  CheckOut,
  RoomOrderQuery,
  FrontDesk,
  FrontDeskOrderDetail,
  FrontGoodsOrder,
  FrontGoodsOrderDetail,
  MemberRecharge,
  MemberRechargeOrderDetail,
  MemberCard,
  MemberCardOrderDetail,
  SelfServiceList,
  SelfServiceDetail,
  SelfServiceReport,
  OrderOperationLog,
  LiveExchangeRoomBI,

  GoodsList,
  GoodsSettle,
  StoreStorage,
  RoomInventoryList,
  StandardStock,
  GoodsManagement,
  LaundryList,
  Record,
  GoodsStock,
  PeripheralManagement,
  PeripheralRental,
  PeripheralStock,

  GuestList,
  GuestQueryList,
  LeaveVisitList,
  ChargeRecord,
  GiveawayCouponHistory,
  ConsumptionAnalysisReport,
  HotelPointsTransactionHistory,
  CardSaleAssistant,

  ComputerList,
  ComputerRecord,
  ComputerCfg,
  CardList,
  ReadIDCard,
  PriceBrandPortal,
  PriceBrandEditor,
  SystemPlatform,

  CentralReservation,
  CentralReservationPromotion,
  StandardPrices,
  MeituanDirect,
  OperateLog,
  Exhibition,
  SurroundingRoomPrice,
  HotelManagement,
  WechatMarketing,
  ChannelOrder,
  ChannelAutoCheckDetail,
  PriceChangeApprove,
  GroupPriceChangeApprove,
  CrsInfoApprove,
  AroundHotelPriceStat,
  DirectPromotion,
  PriceCalendar,

  CashFlowApply,
  CashFlowApplyGroup,
  ReportsDaily,
  ReportsOutlay,
  ReportsHandover,
  ReportsOtaBill,
  ReportsOtaBillDetail,
  ReportsMemberCard,
  ReportsAccountBook,
  ReportsCrossNARefund,
  RefundAccounts,
  PayOrderPortal,
  BillingQuery,
  InvoiceHistory,
  ReconciliationBIReport,
  IncomeForecast,
  GameAppRank,
  ManageReports,
  InvestmentCalculation,

  CrsInvitayion,

  SystemAccount,
  CleanList,
  ReleaseLog,
  ReportsWyBill,
  EmployeeManage,
  GroupEmployeeManage,
  ServiceNotice,
  SystemNoticeGroup,
  SystemNotice,
  ShopownerSOP,
  ShopSOP,
  LicenseManage,
  AttendanceRecordReport,
  ClientIcon,
  EmployeePlayDuration,

  BillList,
  CtripDirect,
  TikTokDirect,

  OperatingExpenses,
  CustomerSatisfaction,
  RegionPlanList,
  RegionPlanDetail,
  ShopProfile,
  LicenseStaticGroup,

  ManualBook,
  StoreAddressBook,
  CompanyAddressBook,
  OnlineSupport,
  ServiceOrder,
  ApplicationBook,
  AboutApplication,
  Complaint,

  // 集团
  TakeCareOfStaticGroup,
  LinenStaticGroup,
  AmenityStaticGroup,
  FeatureAlertStaticGroup,

  LiveExchangeRoomBIGroup,
  ChangeNightPriceBIGroup,

  StoreVoucherStat,
  LeaveVisitStatGroup,
  GroupFlywheelBoard,

  AutoCheckBillGroup,
  OvertimeRoomRateGroup,
  OutstandingAccountsGroup,
  AdjustmentStatisticsGroup,
  InvoiceStatisticsGroup,

  ComputerConfigStatGroup,
  AbnormalBoardRecordGroup,
  gameRankGroup,

  EmployeePlayStatGroup,
  ForecastDashboard,
  CashflowDashboard,
  AchievementDashboard,
  QualityDashboard,
  AchievementAnalysisDashboard,
  SteamHomeIframe,
  IncomeForecastGroup,

  // 集团
  GroupCustomerSatisfaction,
  SopExcuStatistic,
  ShopAttendanceRecordGroup,
  GroupStoreInspect,
  GroupQualityStore,
  SopReport,
  SopReportDetail,
  GroupLaborCost,
  ShopLaborCost,
  GroupShopTour,
  GroupQualityRoom,
  QualityRoom,
  GroupWechatDataStat,

  OperationalReportGroup,
  PerformanceTarget,
  PerformanceTargetDetail,

  BuryPriceAnalysisGroup,
  CashFlowAnalysisGroup,
  MinPriceGroup,

  GroupUnifiedControlPromotion,
  SingleStorePerformanceGroup,
  PriceDifferenceStatisticsGroup,
  GroupDiscountRateAlert,
};
